import React from 'react';
import { DeleteIcon } from 'components/Icons';

type DeleteButtonProps = {
  onClick: () => void,
};

export const DeleteButton = ({ onClick }: DeleteButtonProps) => {
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onClick();
  };

  return (
    <DeleteIcon onClick={handleClick} />
  );
};
